"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _dashboardGridItem = _interopRequireDefault(require("./dashboard-grid/dashboard-grid-item.shape"));

var _default = _propTypes.default.shape({
  videos: _propTypes.default.arrayOf(_dashboardGridItem.default),
  cursor: _propTypes.default.string,
  hasNextPage: _propTypes.default.bool
});

exports.default = _default;